module.exports = __webpack_public_path__ + "media/src/images/zu_teaching01_page9-a67640d724875a77c0b0bd50d8714c95.gif";